import React, {useState, useEffect} from "react";
import axios from "axios";
import Box from "@mui/joy/Box";
import Stack from "@mui/joy/Stack";

import AllTimeCard from '../components/AllTimeCard';
import BillboardCard from '../components/BillboardCard';
import PieChartCard from '../components/PieChartCard';
import LoadingBox from "../components/LoadingBox";
import './styles/home.css';


function Home() {
    const [users, setUsers] = useState([]);
    const [active, setActive] = useState({});
    const [total, setTotal] = useState({});
    const [activeMessengers, setActiveMessengers] = useState([]);
    const [activeChannels, setActiveChannels] = useState([]);
    const [totalMessages, setTotalMessages] = useState({});

    const [loadingUsers, setLoadingUsers] = useState(false);
    const [loadingActive, setLoadingActive] = useState(false);
    const [loadingTotal, setLoadingTotal] = useState(false);
    const [loadingTotalMessages, setLoadingTotalMessages] = useState(false);
    const [loadingActiveChannels, setLoadingActiveChannels] = useState(false);
    const [loadingActiveMessengers, setLoadingActiveMessengers] = useState(false);


    useEffect(() => {
        // Users - Top 10
        axios.get("https://pfc-nmgfbpc62q-uc.a.run.app/users/top10")
            .then(response => {
                setUsers(response.data);
                setLoadingUsers(true);
            })
            .catch(error => console.error(error));

        // Users - Active
        axios.get("https://pfc-nmgfbpc62q-uc.a.run.app/users/active")
            .then(response => {
                setActive(response.data['ActiveUsers']);
                setLoadingActive(true);
            })
            .catch(error => console.error(error));

        // Users - Total
        axios.get("https://pfc-nmgfbpc62q-uc.a.run.app/users/total")
            .then(response => {
                setTotal(response.data['TotalUsers']);
                setLoadingTotal(true);
            })
            .catch(error => console.error(error));

        // Messages - Active Channels
        axios.get("https://pfc-nmgfbpc62q-uc.a.run.app/messages/activeChannel")
            .then(response => {
                setActiveChannels(response.data);
                setLoadingActiveChannels(true);
            })
            .catch(error => console.error(error));

        // Messages - Active Messengers
        axios.get("https://pfc-nmgfbpc62q-uc.a.run.app/messages/activeMessenger")
            .then(response => {
                setActiveMessengers(response.data);
                setLoadingActiveMessengers(true);
            })
            .catch(error => console.error(error));

        // Messages - Total
        axios.get("https://pfc-nmgfbpc62q-uc.a.run.app/messages/total")
            .then(response => {
                setTotalMessages(response.data['TotalMessages']);
                setLoadingTotalMessages(true);
            })
            .catch(error => console.error(error));
    }, []);

    return (
        <Box className="pattern">
            <Box className="center">
                { (loadingActive && loadingUsers && loadingTotal && loadingActiveMessengers && loadingActiveChannels && loadingTotalMessages) ?
                    (
                        <Box sx={{ width: '100%', minWidth: 0 }}>
                            <Stack direction='column' spacing={2} sx={{ width: '100%', minWidth: 0 }}>
                                <Box
                                    sx={{
                                        display: 'grid',
                                        gap: 2,
                                        gridTemplateColumns: { xs: 'repeat(2, minmax(0, 1fr))', md: 'repeat(4, minmax(0, 1fr))' },
                                    }}
                                >
                                    <BillboardCard name='Messages per Minutes' time='1 month' value={(totalMessages/43800).toPrecision(2)} color='sand'/>
                                    <BillboardCard name='Messages Sent' time='1 month' value={totalMessages} color='orchid'/>
                                    <BillboardCard name='Active Users' time='1 hour' value={active} color='slate'/>
                                    <BillboardCard name='Total Users' time='forever' value={total} color='gold'/>
                                </Box>
                                <Box
                                    sx={{
                                        display: 'grid',
                                        gap: 2,
                                        gridTemplateColumns: { xs: 'minmax(0, 1fr)', md: 'repeat(2, minmax(0, 1fr))' },
                                    }}
                                >
                                    <PieChartCard name='Most Active Users' time='1 month' chartData={activeMessengers}/>
                                    <PieChartCard name='Most Active Channel' time='1 month' chartData={activeChannels}/>
                                </Box>
                                <AllTimeCard name='Total Users' time='2 month' users={users}/>
                            </Stack>
                        </Box>
                    )
                    :
                    (
                        <Box className="loading-icon">
                            <LoadingBox/>
                        </Box>
                    )
                }
            </Box>
        </Box>
    );
}

export default Home;
